/**
=========================================================
* Politique de confidentialité - expressiontcf.com
=========================================================

Dernière mise à jour : 01 mai 2026
=========================================================
*/

import { Box, Container, Typography, Paper, Divider } from "@mui/material";
import OfficialHeader from "components/OfficialHeader";
import OfficialFooter from "components/OfficialFooter";

function PrivacyPolicy() {
  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <OfficialHeader />

      <Box
        sx={{
          backgroundColor: "#f8fafc",
          py: 8,
          flex: 1,
        }}
      >
        <Container maxWidth="lg">
          <Paper
            elevation={0}
            sx={{
              p: 8,
              borderRadius: "8px",
              backgroundColor: "#ffffff",
              boxShadow: "0px 4px 6px -1px rgba(0,0,0,0.1), 0px 2px 4px -1px rgba(0,0,0,0.06)",
            }}
          >
            <Box sx={{ mb: 6 }}>
              <Typography
                variant="h1"
                sx={{
                  fontSize: "48px",
                  fontWeight: 700,
                  lineHeight: 1.25,
                  color: "#212529",
                  mb: 3,
                  textAlign: "center",
                }}
              >
                Politique de confidentialité
              </Typography>

              <Typography
                variant="h6"
                sx={{
                  fontSize: "20px",
                  fontWeight: 400,
                  lineHeight: 1.625,
                  color: "#7b809a",
                  textAlign: "center",
                  mb: 2,
                }}
              >
                expressiontcf.com
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 300,
                  lineHeight: 1.6,
                  color: "#7b809a",
                  textAlign: "center",
                }}
              >
                Dernière mise à jour : 01 mai 2026
              </Typography>
            </Box>

            <Divider sx={{ my: 6 }} />

            <Box sx={{ mb: 6 }}>
              <Typography
                variant="h4"
                sx={{
                  fontSize: "24px",
                  fontWeight: 700,
                  lineHeight: 1.375,
                  color: "#212529",
                  mb: 3,
                }}
              >
                1. Objet
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: 1.625,
                  color: "#7b809a",
                  mb: 2,
                }}
              >
                La présente politique de confidentialité a pour objectif d’informer les utilisateurs du site expressiontcf.com sur la manière dont leurs données personnelles sont collectées, utilisées et protégées.
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: 1.625,
                  color: "#7b809a",
                }}
              >
                Une politique de confidentialité est un document obligatoire qui explique comment un site traite les données personnelles de ses utilisateurs.
              </Typography>
            </Box>

            <Box sx={{ mb: 6 }}>
              <Typography
                variant="h4"
                sx={{
                  fontSize: "24px",
                  fontWeight: 700,
                  lineHeight: 1.375,
                  color: "#212529",
                  mb: 3,
                }}
              >
                2. Identité du responsable du traitement
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: 1.625,
                  color: "#7b809a",
                  mb: 2,
                }}
              >
                Le site expressiontcf.com est un service proposé par la plateforme Réussir TCF Canada.
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: 1.625,
                  color: "#7b809a",
                  mb: 2,
                }}
              >
                📧 Contact : info@reussir-tcfcanada.com
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: 1.625,
                  color: "#7b809a",
                }}
              >
                Le responsable du traitement des données est la structure éditrice de cette plateforme.
              </Typography>
            </Box>

            <Box sx={{ mb: 6 }}>
              <Typography
                variant="h4"
                sx={{
                  fontSize: "24px",
                  fontWeight: 700,
                  lineHeight: 1.375,
                  color: "#212529",
                  mb: 3,
                }}
              >
                3. Données collectées
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: 1.625,
                  color: "#7b809a",
                  mb: 2,
                }}
              >
                Nous pouvons collecter les données suivantes :
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 600,
                  lineHeight: 1.625,
                  color: "#212529",
                  mb: 1,
                }}
              >
                3.1 Données fournies directement
              </Typography>

              <Box component="ul" sx={{ pl: 3, mb: 2 }}>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a", mb: 1 }}>
                  Nom et prénom
                </Typography>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a", mb: 1 }}>
                  Adresse email
                </Typography>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a", mb: 1 }}>
                  Informations de paiement (via prestataire sécurisé)
                </Typography>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a" }}>
                  Contenus soumis (expressions écrites ou orales)
                </Typography>
              </Box>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 600,
                  lineHeight: 1.625,
                  color: "#212529",
                  mb: 1,
                }}
              >
                3.2 Données collectées automatiquement
              </Typography>

              <Box component="ul" sx={{ pl: 3, mb: 2 }}>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a", mb: 1 }}>
                  Adresse IP
                </Typography>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a", mb: 1 }}>
                  Type d’appareil et navigateur
                </Typography>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a", mb: 1 }}>
                  Données de navigation
                </Typography>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a" }}>
                  Historique d’utilisation des crédits
                </Typography>
              </Box>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: 1.625,
                  color: "#7b809a",
                }}
              >
                👉 Ces données sont généralement collectées lors de l’inscription, de l’achat ou de l’utilisation du service.
              </Typography>
            </Box>

            <Box sx={{ mb: 6 }}>
              <Typography
                variant="h4"
                sx={{
                  fontSize: "24px",
                  fontWeight: 700,
                  lineHeight: 1.375,
                  color: "#212529",
                  mb: 3,
                }}
              >
                4. Finalité de la collecte
              </Typography>

              <Box component="ul" sx={{ pl: 3, mb: 2 }}>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a", mb: 1 }}>
                  Créer et gérer votre compte
                </Typography>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a", mb: 1 }}>
                  Fournir les services de simulation IA
                </Typography>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a", mb: 1 }}>
                  Gérer vos crédits d’utilisation
                </Typography>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a", mb: 1 }}>
                  Améliorer la qualité du service
                </Typography>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a", mb: 1 }}>
                  Assurer la sécurité du site
                </Typography>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a" }}>
                  Traiter les paiements et demandes de remboursement
                </Typography>
              </Box>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: 1.625,
                  color: "#7b809a",
                }}
              >
                👉 Toute politique doit expliquer clairement pourquoi les données sont collectées.
              </Typography>
            </Box>

            <Box sx={{ mb: 6 }}>
              <Typography
                variant="h4"
                sx={{
                  fontSize: "24px",
                  fontWeight: 700,
                  lineHeight: 1.375,
                  color: "#212529",
                  mb: 3,
                }}
              >
                5. Base légale du traitement
              </Typography>

              <Box component="ul" sx={{ pl: 3, mb: 2 }}>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a", mb: 1 }}>
                  L’exécution du contrat (utilisation du service)
                </Typography>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a", mb: 1 }}>
                  Le consentement de l’utilisateur
                </Typography>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a" }}>
                  L’intérêt légitime (amélioration du service, sécurité)
                </Typography>
              </Box>
            </Box>

            <Box sx={{ mb: 6 }}>
              <Typography
                variant="h4"
                sx={{
                  fontSize: "24px",
                  fontWeight: 700,
                  lineHeight: 1.375,
                  color: "#212529",
                  mb: 3,
                }}
              >
                6. Conservation des données
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: 1.625,
                  color: "#7b809a",
                }}
              >
                Les données sont conservées :
              </Typography>

              <Box component="ul" sx={{ pl: 3, mb: 2 }}>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a", mb: 1 }}>
                  Pendant toute la durée d’utilisation du compte
                </Typography>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a" }}>
                  Puis archivées pendant une durée raisonnable pour obligations légales
                </Typography>
              </Box>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: 1.625,
                  color: "#7b809a",
                }}
              >
                👉 Les politiques doivent préciser la durée de conservation des données.
              </Typography>
            </Box>

            <Box sx={{ mb: 6 }}>
              <Typography
                variant="h4"
                sx={{
                  fontSize: "24px",
                  fontWeight: 700,
                  lineHeight: 1.375,
                  color: "#212529",
                  mb: 3,
                }}
              >
                7. Partage des données
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: 1.625,
                color: "#7b809a",
                  mb: 2,
                }}
              >
                Les données peuvent être partagées uniquement avec :
              </Typography>

              <Box component="ul" sx={{ pl: 3, mb: 2 }}>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a", mb: 1 }}>
                  Prestataires techniques (hébergement, paiement)
                </Typography>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a", mb: 1 }}>
                  Outils d’analyse et d’amélioration du service
                </Typography>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a" }}>
                  Autorités légales si requis
                </Typography>
              </Box>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: 1.625,
                  color: "#7b809a",
                }}
              >
                ❌ Aucune vente de données personnelles n’est effectuée.
              </Typography>
            </Box>

            <Box sx={{ mb: 6 }}>
              <Typography
                variant="h4"
                sx={{
                  fontSize: "24px",
                  fontWeight: 700,
                  lineHeight: 1.375,
                  color: "#212529",
                  mb: 3,
                }}
              >
                8. Sécurité des données
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: 1.625,
                  color: "#7b809a",
                }}
              >
                Nous mettons en place des mesures de sécurité pour protéger vos données :
              </Typography>

              <Box component="ul" sx={{ pl: 3, mb: 2 }}>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a", mb: 1 }}>
                  Hébergement sécurisé
                </Typography>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a", mb: 1 }}>
                  Accès restreint aux données
                </Typography>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a" }}>
                  Protocoles de protection contre les accès non autorisés
                </Typography>
              </Box>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: 1.625,
                  color: "#7b809a",
                }}
              >
                👉 La protection des données est une obligation légale pour les sites web.
              </Typography>
            </Box>

            <Box sx={{ mb: 6 }}>
              <Typography
                variant="h4"
                sx={{
                  fontSize: "24px",
                  fontWeight: 700,
                  lineHeight: 1.375,
                  color: "#212529",
                  mb: 3,
                }}
              >
                9. Cookies
              </Typography>

              <Box component="ul" sx={{ pl: 3, mb: 2 }}>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a", mb: 1 }}>
                  Améliorer l’expérience utilisateur
                </Typography>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a", mb: 1 }}>
                  Analyser le trafic
                </Typography>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a" }}>
                  Personnaliser le contenu
                </Typography>
              </Box>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: 1.625,
                  color: "#7b809a",
                }}
              >
                Vous pouvez configurer votre navigateur pour refuser les cookies.
              </Typography>
            </Box>

            <Box sx={{ mb: 6 }}>
              <Typography
                variant="h4"
                sx={{
                  fontSize: "24px",
                  fontWeight: 700,
                  lineHeight: 1.375,
                  color: "#212529",
                  mb: 3,
                }}
              >
                10. Droits des utilisateurs
              </Typography>

              <Box component="ul" sx={{ pl: 3, mb: 2 }}>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a", mb: 1 }}>
                  Droit d’accès à vos données
                </Typography>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a", mb: 1 }}>
                  Droit de rectification
                </Typography>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a", mb: 1 }}>
                  Droit de suppression
                </Typography>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a", mb: 1 }}>
                  Droit d’opposition
                </Typography>
                <Typography component="li" variant="body2" sx={{ fontSize: "16px", fontWeight: 400, lineHeight: 1.625, color: "#7b809a" }}>
                  Droit à la limitation du traitement
                </Typography>
              </Box>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: 1.625,
                  color: "#7b809a",
                }}
              >
                👉 Vous pouvez exercer ces droits à tout moment.
              </Typography>
            </Box>

            <Box sx={{ mb: 6 }}>
              <Typography
                variant="h4"
                sx={{
                  fontSize: "24px",
                  fontWeight: 700,
                  lineHeight: 1.375,
                  color: "#212529",
                  mb: 3,
                }}
              >
                11. Exercice des droits
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: 1.625,
                  color: "#7b809a",
                  mb: 2,
                }}
              >
                Pour toute demande :
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: 1.625,
                  color: "#7b809a",
                  mb: 2,
                }}
              >
                📧 info@reussir-tcfcanada.com
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: 1.625,
                  color: "#7b809a",
                }}
              >
                expressiontcf.com est un service proposé par la plateforme Réussir TCF Canada.
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: 1.625,
                  color: "#7b809a",
                }}
              >
                Toutes les demandes liées aux données personnelles sont traitées via cette adresse.
              </Typography>
            </Box>

            <Box sx={{ mb: 6 }}>
              <Typography
                variant="h4"
                sx={{
                  fontSize: "24px",
                  fontWeight: 700,
                  lineHeight: 1.375,
                  color: "#212529",
                  mb: 3,
                }}
              >
                12. Transfert des données
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: 1.625,
                  color: "#7b809a",
                }}
              >
                Les données peuvent être hébergées ou traitées en dehors de votre pays, tout en respectant les normes de protection applicables.
              </Typography>
            </Box>

            <Box sx={{ mb: 6 }}>
              <Typography
                variant="h4"
                sx={{
                  fontSize: "24px",
                  fontWeight: 700,
                  lineHeight: 1.375,
                  color: "#212529",
                  mb: 3,
                }}
              >
                13. Modification de la politique
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: 1.625,
                  color: "#7b809a",
                }}
              >
                expressiontcf.com se réserve le droit de modifier cette politique à tout moment.
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: 1.625,
                  color: "#7b809a",
                  mt: 2,
                }}
              >
                Les utilisateurs seront informés en cas de modification importante.
              </Typography>
            </Box>

            <Box sx={{ mb: 6 }}>
              <Typography
                variant="h4"
                sx={{
                  fontSize: "24px",
                  fontWeight: 700,
                  lineHeight: 1.375,
                  color: "#212529",
                  mb: 3,
                }}
              >
                14. Acceptation
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: 1.625,
                  color: "#7b809a",
                }}
              >
                En utilisant le site, vous acceptez la présente politique de confidentialité.
              </Typography>
            </Box>
          </Paper>
        </Container>
      </Box>

      <OfficialFooter />
    </Box>
  );
}

export default PrivacyPolicy;
